import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface SubmitRequestInvoiceApiParameter extends ApiParameter {
    CustomerNumber: string;
    DocumentType: string;
    DocumentNumber: string;
}

const requestInvoiceUrl = "/api/v1/download/getpdf";

export function submitRequestInvoice(parameter: SubmitRequestInvoiceApiParameter) {
    return post<SubmitRequestInvoiceApiParameter>(requestInvoiceUrl, parameter);
}
